import { render, staticRenderFns } from "./CollaborateurDocumentAskingProfile.vue?vue&type=template&id=642bb162&"
import script from "./CollaborateurDocumentAskingProfile.vue?vue&type=script&lang=js&"
export * from "./CollaborateurDocumentAskingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports